export default __webpack_public_path__ + "static/media/Image.2b740146.png";